import Vue from 'vue'
import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'

import 'dayjs/locale/en'
import 'dayjs/locale/ja'

dayjs.extend(LocalizedFormat)

Vue.prototype.$dayjs = dayjs

export default {
    install(Vue) {
        Vue.prototype.$dayjs = dayjs
    },
}
